import { render, staticRenderFns } from "./merchantManage.vue?vue&type=template&id=470bf09b&scoped=true"
import script from "./merchantManage.vue?vue&type=script&lang=js"
export * from "./merchantManage.vue?vue&type=script&lang=js"
import style0 from "./merchantManage.vue?vue&type=style&index=0&id=470bf09b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470bf09b",
  null
  
)

export default component.exports